import { render, staticRenderFns } from "./ChatTrain.vue?vue&type=template&id=71da5a72&scoped=true"
import script from "./ChatTrain.vue?vue&type=script&lang=js"
export * from "./ChatTrain.vue?vue&type=script&lang=js"
import style0 from "./ChatTrain.vue?vue&type=style&index=0&id=71da5a72&prod&lang=css"
import style1 from "./ChatTrain.vue?vue&type=style&index=1&id=71da5a72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71da5a72",
  null
  
)

export default component.exports